module.exports = __webpack_public_path__ + "static/media/iconStudentBoys.6af2be3d.svg";